import React, { ReactNode } from 'react';

import { AccessControlWrapper } from '@/common/components';
import { REQUESTED } from '@/constants';
import ApproveChangeRequest from '@/features/change-request/approve';
import { AdaptiveExperiment, Experiment } from '@/lib/PlannerDTOs';
import { AccessTargetInput, UserAction } from '@/utils/accessControl';
import { isWhitelistedApprover } from '@/utils/experiment';
import { useAppNavigate } from '@/utils/navigation';

const Approve = ({
  variableTechFamilies,
  experiment,
  adaptiveExperiment,
  ghost,
  icon,
  accessTargets,
}: {
  variableTechFamilies: string[];
  experiment: Experiment;
  adaptiveExperiment: AdaptiveExperiment;
  ghost?: boolean;
  icon?: ReactNode;
  accessTargets?: AccessTargetInput[];
}) => {
  const { navigateTo } = useAppNavigate();

  const mainExperiment = experiment || adaptiveExperiment;

  if (experiment?.state !== REQUESTED) return null;

  if (isWhitelistedApprover(experiment?.approvalFlow?.data || [])) {
    return (
      <ApproveChangeRequest
        experiment={mainExperiment as Experiment}
        onSuccess={() => {
          navigateTo('/t/experiments');
        }}
        ghost={ghost}
        icon={icon}
      />
    );
  }

  return (
    <AccessControlWrapper
      action={UserAction.APPROVE_CURRENT_EXPERIMENT}
      techFamilies={variableTechFamilies}
      accessTargets={accessTargets}
    >
      {(hasAccess: boolean) => (
        <ApproveChangeRequest
          experiment={mainExperiment as Experiment}
          disabled={!hasAccess}
          onSuccess={() => {
            navigateTo('/t/experiments');
          }}
          ghost={ghost}
          icon={icon}
        />
      )}
    </AccessControlWrapper>
  );
};

export default Approve;
